import {Brick, registerBrick} from 'olympe';

/**
 * The delete method of Set instances removes a value from a Set.
 */
export default class DeleteFromSet extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {Set} set
     * @param {*} value
     * @param {function()} forwardEvent
     * @param {function(Set)} setSet
     * @param {function(boolean)} setDeletedSomething
     */
    update($, [set, value], [forwardEvent, setSet, setDeletedSomething]) {
        setDeletedSomething(set.delete(value));
        setSet(set);
        forwardEvent();
    }
}

registerBrick('018a6f110a84ed9bbfd0', DeleteFromSet);
